import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../admin/common/loader";
import { capitalizeFirstLetter, formateDate } from "../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { Details } from "../../admin/services/subscriptionPlan.services";
import Breadcrums from "../../admin/common/breadcrumbs";
import { Placeholder} from "rsuite";

const SubscriptionView = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const params = useParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    {
      title: "Subscription Plans",
      url: "/admin/subscription/subscription-plan/list/1",
    },
    { title: t("btn_view"), url: "" },
  ];


  useEffect(() => {
    Details(params._id)
      .then((response) => {
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params._id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">{t("btn_view") + " " + t("Subscription Plan")}</h6>
              </div>
              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>
                        <tr>
                          <th>{t("label_name")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.name
                              ? showdefault.name
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_status")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.status && showdefault.status === 1
                              ? <span className="badge badge-success p-1">{t('btn_active')}</span>
                              : <span className="badge badge-success p-1">{t('btn_inactive')}</span>}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_description")}</th>
                          <td>
                            {showdefault && showdefault.description
                              ? capitalizeFirstLetter(showdefault.description)
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Taglines")}</th>
                          <td>
                            {showdefault && showdefault.taglines && showdefault.taglines.length > 0 ? (
                              <ul className="list-unstyled mb-0">
                                {showdefault.taglines.map((tagline, idx) => (
                                  <li key={idx} className="mb-1 d-flex align-items-center">
                                    <i className="fa fa-check text-warning mr-2"></i>
                                    <span>{tagline}</span>
                                  </li>
                                ))}
                              </ul>
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Price")}</th>
                          <td>
                            £{showdefault && showdefault.price && showdefault.price
                              ? showdefault.price
                              : "N/A"}
                          </td>
                        </tr>
                         <tr>
                          <th>{t("Type")}</th>
                          <td>
                            {showdefault && showdefault.type
                              ? capitalizeFirstLetter(showdefault.type)
                              : "N/A"}
                          </td>
                        </tr>
                        {/* <tr>
                          <th>{t("label_role")}</th>
                          <td>
                            {showdefault && showdefault?.allowedRoles
                              ? showdefault.allowedRoles.map((role) => t(role)).join(", ")
                              : "N/A"}
                          </td>
                        </tr> */}
                        {/* <tr>
                          <th>{t("label_stripe_plan_id")}</th>
                          <td>
                            {showdefault && showdefault.stripePlanID
                              ? showdefault.stripePlanID
                              : "N/A"}
                          </td>
                        </tr> */}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <Placeholder.Paragraph className="w-100" rowHeight={30} rowSpacing={5} active={true} rows={7}/>
              )}
              <div className="mt-2 back-button mx-4">
                <button
                  className="btn ripple btn-dark"
                  type="button"
                  onClick={() =>
                    navigate("/admin/subscription/subscription-plan/list/1")
                  }
                >
                  <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                  {t("btn_back")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubscriptionView;
